// Discreet in-app "new message" cue: a soft two-note ding (Web Audio, no asset)
// + a short vibration. User-toggleable and remembered in localStorage.
const KEY = "yalola.msg_sound";

export const isMsgSoundOn = () => {
  try { return localStorage.getItem(KEY) !== "off"; } catch { return true; }
};
export const setMsgSound = (on) => {
  try { localStorage.setItem(KEY, on ? "on" : "off"); } catch { /* noop */ }
};

let ctx;
export function playMessagePing() {
  if (!isMsgSoundOn()) return;
  try { navigator.vibrate?.(30); } catch { /* noop */ }
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    // A5 -> D6, quick gentle ding
    [[880, 0], [1174.66, 0.09]].forEach(([freq, at]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = freq;
      o.connect(g);
      g.connect(ctx.destination);
      const start = now + at;
      g.gain.setValueAtTime(0.0001, start);
      g.gain.exponentialRampToValueAtTime(0.11, start + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, start + 0.18);
      o.start(start);
      o.stop(start + 0.2);
    });
  } catch { /* noop */ }
}
